export default __webpack_public_path__ + "static/media/lob.9ef5b790.svg";